import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';

// extend the ComponentDefinition type with the additional fields for the component
interface DropDownExComponentDefinition extends ComponentDefinition {
  dropDownExList?: any[];
  style?: string;
  multiSelect?: boolean;
}

@Component({
  templateUrl: './drop-down-ex.component.html',
  styleUrls: ['./drop-down-ex.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropDownExComponent extends AbstractComponent<DropDownExComponentDefinition> implements OnInit {
  isMultiple: any;
  fullWidth: any;
  itemList: any[];

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    private sanitizer: DomSanitizer,
    protected setupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, setupService, cdr);
  }

  ngOnInit() {

    this.shouldNotifyCompInitializedInSuper = false;

    super.ngOnInit();

    if (this.componentDefinition.hasOwnProperty('multiSelect')) {
      this.isMultiple = this.componentDefinition.multiSelect;
    }

    if (this.componentDefinition.hasOwnProperty('fullWidth')) {
      if (this.componentDefinition.fullWidth === true) {
        this.fullWidth = this.sanitizer.bypassSecurityTrustStyle('width:100%');
      } else {
        // this.fullWidth = this.sanitizer.bypassSecurityTrustStyle('width:15%');
      }
    } else {
      // this.fullWidth = this.sanitizer.bypassSecurityTrustStyle('width:15%');
    }

  }

  initializeFieldValue() {
    this.getItemFromParent(this.fieldValue || this.componentDefinition.dropDownExList[0].parent);

    setTimeout(() => {
      this.detectChanges();
    });
  }

  isMandatory() {
    if (this.componentDefinition.hasOwnProperty('mandatory')) {
      if (this.componentDefinition.mandatory === true) {
        const reStyle = 'required';
        return this.componentDefinition.mandatory;
      } else {
        const reStyle = 'notrequired';
        return this.componentDefinition.mandatory;
      }
    } else {
      const isMandatory = false;
      const reStyle = 'notrequired';
      return isMandatory;
    }
  }

  colorize() {
    if (this.componentDefinition.hasOwnProperty('mandatory')) {
      if (this.componentDefinition.mandatory === true) {
        const reStyle = 'required';
        return reStyle;
      } else {
        const reStyle = 'notrequired';
        return reStyle;
      }
    } else {
      const reStyle = 'notrequired';
      return reStyle;
    }
  }

  getItemFromParent(parentName) {
    let dataReturn = this.itemList;
    for (let i = 0, len = this.componentDefinition.dropDownExList.length; i < len; i++) {
      if (this.componentDefinition.dropDownExList[i].parent === parentName) {
        dataReturn = this.componentDefinition.dropDownExList[i].item;
        break;
      }
    }
    this.itemList = dataReturn;
  }

  trackByFn(index, item) {
    return item;
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }

  onFieldValueChanged(fieldValue) {
    if (this.fieldValue === fieldValue) {
      return;
    }

    if (this.isMultiple && !Array.isArray(fieldValue)) {

      if (this.fieldValue.join(',') === fieldValue) {
        return;
      }

      fieldValue = fieldValue.split(',');
    }

    this.fieldValue = fieldValue;
    if (this.formControl) {
      this.formControl.patchValue(this.fieldValue, {emitEvent: false, onlySelf: true});
    }
    this.getItemFromParent(this.fieldValue);
    this.detectChanges();
  }
}
